import { useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../../common/http-common";
import * as common from "../../../common/common";
import * as Comp from "../../../common/CommonComponents";

const UserDelete = (props) => {
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);
  const hideModal = () => {
    props.onHide();
  };

  const deleteBtnOnClick = () => {
    RemoveUser(props.editData);
  };

  const RemoveUser = (_data) => {
    let functionName = "";

    try {
      functionName = props.page + RemoveUser.name;

      props.onLoading(true, "Deleting user, please wait...");
      props.onHide();
      const selectedRoleList =
        props.editData.ROLE_ID === null || props.editData.ROLE_ID === undefined
          ? ""
          : props.editData.ROLE_ID.split(",");
      const data = {
        USER_ID: _data.USER_ID,
        USER_SHORT_NAME: _data.USER_SHORT_NAME,
        USER_ROLE_LIST: selectedRoleList,
        UPDATE_ID: userId,
        // FROM_SOURCE: { SOURCE: "WEB" MODULE_ID: props.module},
      };

      http
        .put("api/users/DeleteUser", data, { timeout: 5000 })
        .then(() => {
          toast.success("User is successfully deleted.");
          props.onReload();
        })
        .catch((err) => {
          toast.error("Failed to delete user. Please try again.");
          common.c_LogWebError(props.page, functionName, err);
        })
        .finally(() => {
          props.onLoading(false, "Loading...");
        });
    } catch (err) {
      props.onLoading(false, "Loading...");
      toast.error("Failed to delete user. Please try again.");
      common.c_LogWebError(props.page, functionName, err);
    }
  };

  const message = (
    <>
      Confirm to delete?
      <br />
      Username:
      {<b> {props.editData !== null && props.editData.USER_SHORT_NAME}</b>}
    </>
  );

  return (
    <>
      <Comp.ConfirmModal
        show={props.showHide}
        onHide={hideModal}
        onConfirm={deleteBtnOnClick}
        delete
      >
        {message}
      </Comp.ConfirmModal>
    </>
  );
};

export default UserDelete;
